import { STORE_ID } from '@/js/api/const.ts';
import { makeRequest } from '@/js/api/request-service.ts';

export async function addFavorite(productId: number) {
  return makeRequest({
    method: 'GET',
    url: `/api/${STORE_ID}/favorites/product/${productId}/push`,
  });
}

export async function removeFavorite(productId: number) {
  return makeRequest({
    method: 'GET',
    url: `/api/${STORE_ID}/favorites/product/${productId}/remove`,
  });
}
